<template>
	<article class="iv2-article">
		<div class="container">
			<div class="iv2-error-404">
				<h1 class="iv2-error-404-number">{{ $t('system.page404.status') }}</h1>
				<h2 class="iv2-error-404-lead">{{ $t('system.page404.lead') }}</h2>
				<p class="iv2-error-404-summary text-pre">{{ $t('system.page404.summary') }}</p>
				<div class="row clearfix">
					<div class="column full text-center">
						<span>
							<router-link
								to="/"
								class="iv2-error-404-btn theme__main-btn is-btn is-btn-ghost2 is-upper"
							>{{ $t('system.button') }}</router-link>
						</span>
					</div>
				</div>
			</div>
		</div>
	</article>
</template>

<script>
export default {};
</script>

<style lang="scss">
.iv2-error-404 {
	padding: 10rem 0;

	.iv2-error-404-number {
		text-align: center;
		padding: 0 2rem;
		font-size: 5.5rem;
	}

	.iv2-error-404-lead {
		text-align: center;
		font-size: 1.5rem;
		font-weight: 600;
		padding: 2rem 1rem;
		margin: 0;
	}

	.iv2-error-404-summary {
		text-align: center;
		padding: 0 1rem 2rem 1rem;
		margin: 0;
	}

	.iv2-error-404-btn {
		border: 0;
		font-size: 18px;
		letter-spacing: 2px;
		padding-top: 15px;
		padding-bottom: 15px;
		width: 300px;
		max-width: 100%;
	}
}

@media (max-width: 1199px) {
	.iv2-error-404 {
		height: 80vh;

		.iv2-error-404-lead {
			font-size: 1rem;
		}
	}
}

@media (min-width: 768px) and (max-width: 1199px) {
	.iv2-error-404 {
		padding: 14rem 0;
	}
}
</style>
